"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "វេទិកាបណ្តុះបណ្តាលតាមអ៊ិនធឺរណែត Liaogao e Academy",
    "captchaNotEmpty": "លេខកូដផ្ទៀងផ្ទាត់ត្រូវតែបំពេញ",
    "accountNotEmpty": "គណនីមិនអាចទទេបានទេ",
    "passwordBits": "ប្រវែងពាក្យសម្ងាត់មិនអាចតិចជាង ៦ ខ្ទង់ទេ",
    "incorrectTips": "ឈ្មោះអ្នកប្រើឬពាក្យសម្ងាត់បានបញ្ចូលមិនត្រឹមត្រូវ",
    "sign": "ចូល",
    "passwordNotEmpty": "ពាក្យសម្ងាត់មិនអាចត្រូវបានទទេ",
    "passwordBitsLong": "ប្រវែងពាក្យសម្ងាត់មិនអាចធំជាង ១៨ តួ",
    "captchaTips": "លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ",
    "confirmNot": "ពាក្យសម្ងាត់ដែលបានបញ្ចូលមិនត្រូវគ្នានឹងពាក្យសម្ងាត់ដែលបានបញ្ជាក់ទេ",
    "inputAccount": "សូមបញ្ចូលឈ្មោះអ្នកប្រើ",
    "inputPassword": "សូមបញ្ចូលពាក្យសម្ងាត់",
    "inputCaptcha": "សូមបញ្ចូលលេខកូដផ្ទៀងផ្ទាត់",
    "forgetPassword": "ភ្លេចលេខសំងាត់",
    "nextStep": "ជំហាន​បន្ទាប់",
    "inputUserName": "សូមបញ្ចូលឈ្មោះអ្នកប្រើ",
    "phoneNumber": "លេខទូរសព្ទ",
    "phoneEmpty": "លេខទូរស័ព្ទមិនអាចទទេបានទេ",
    "surePasswordEmpty": "បញ្ជាក់លេខសម្ងាត់មិនអាចទុកនៅទទេបានទេ",
    "userNameEmpty": "ឈ្មោះអ្នកប្រើមិនអាចទទេបានទេ",
    "getCaptcha": "ទទួលបានលេខកូដផ្ទៀងផ្ទាត់",
    "msgCaptcha": "លេខកូដផ្ទៀងផ្ទាត់ SMS",
    "prevStep": "មុន",
    "surePassword": "សូមបញ្ជាក់ពាក្យសម្ងាត់របស់អ្នក",
    "reset": "កំណត់ឡើងវិញ",
    "resetSuccess": "កំណត់ឡើងវិញដោយជោគជ័យ",
    "resetSuccessTips": "អ្នកបានកំណត់លេខសំងាត់របស់អ្នកឡើងវិញដោយជោគជ័យសូមចូលដើម្បីចូល",
    "loginNow": "ចូលឥឡូវ",
    "copyRight": "រក្សាសិទ្ធិគ្រប់គ្រងដោយ owned, រក្សាសិទ្ធិ @ ២០២០ 京អាយ។ ភី។ ភី备案",
    "loginFail": "ការចូលបានបរាជ័យសូមព្យាយាមម្តងទៀត!",
    "captchaFail": "ការផ្ទៀងផ្ទាត់លេខកូដបានបរាជ័យ",
    "failTips": "ការផ្ទៀងផ្ទាត់បានបរាជ័យ",
    "inputOrigPassword": "សូមបញ្ចូលពាក្យសម្ងាត់ដើម",
    "inputNewPassowrd": "សូមបញ្ចូលពាក្យសម្ងាត់ថ្មី",
    "confimPassword": "សូមបញ្ជាក់ពាក្យសម្ងាត់របស់អ្នក",
    "sure": "កំណត់",
    "cancel": "បោះបង់",
    "changePasswordSuccess": "ពាក្យសម្ងាត់ត្រូវបានធ្វើឱ្យទាន់សម័យ",
    "continueLogin": "ចុះឈ្មោះឡើងវិញ",
    "resetLoginTips": "អ្នកបានផ្លាស់ប្តូរពាក្យសម្ងាត់របស់អ្នកដោយជោគជ័យអ្នកត្រូវចូលម្តងទៀតហើយចាកចេញដោយស្វ័យប្រវត្តិបន្ទាប់ពី ៣ វិនាទី",
    "passwordFormat": "ប្រវែងពាក្យសម្ងាត់គឺពី ៨ ទៅ ៣២ ខ្ទង់រួមទាំងលេខអក្សរធំនិងអក្សរតូច",
    "changePassword": "ផ្លាស់ប្តូរពាក្យសម្ងាត់",
    "poor": "ខ្សោយ",
    "middle": "ក្នុង",
    "strong": "ខ្លាំង",
    "logout": "ចេញដោយជោគជ័យ",
    "formerPhone": "លេខទូរស័ព្ទដើម",
    "newPhone": "លេខទូរស័ព្ទថ្មី",
    "changePhoneSuccess": "ផ្លាស់ប្តូរលេខទូរស័ព្ទដៃដោយជោគជ័យ",
    "changePhoneSuccessTips": "អ្នកបានកែប្រែលេខទូរស័ព្ទរបស់អ្នកដោយជោគជ័យ",
    "goHome": "ចូលទៅគេហទំព័រ",
    "changePhone": "កែប្រែលេខទូរស័ព្ទដៃ",
    "newPhoneEmpty": "លេខទូរស័ព្ទថ្មីមិនអាចទទេបានទេ",
    "newPhoneFomat": "ទ្រង់ទ្រាយលេខទូរស័ព្ទថ្មីមិនត្រឹមត្រូវ",
    "newPhoneSupport": "លេខទូរស័ព្ទថ្មីមិនអាចដូចគ្នានឹងលេខទូរស័ព្ទដើមទេ",
    "newPhoneBinded": "លេខទូរស័ព្ទថ្មីបានជាប់ចំណង",
    "orgPhoneEmpty": "លេខទូរស័ព្ទដើមមិនអាចទទេបានទេ",
    "orgPhoneFormat": "ទ្រង់ទ្រាយលេខទូរស័ព្ទដើមមិនត្រឹមត្រូវ",
    "orgPhoneNot": "លេខទូរស័ព្ទដើមមិនត្រឹមត្រូវ",
    "resetPassword": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    "phoneCaptchaEmpty": "លេខកូដផ្ទៀងផ្ទាត់ទូរស័ព្ទមិនអាចទទេបានទេ",
    "accountVerif": "ការផ្ទៀងផ្ទាត់គណនី",
    "phoneVerif": "ការផ្ទៀងផ្ទាត់តាមទូរស័ព្ទ",
    "resetDone": "កំណត់ឡើងវិញរួចរាល់",
    "phoneFormat": "ទ្រង់ទ្រាយលេខទូរស័ព្ទមិនត្រឹមត្រូវ",
    "phoneBinded": "លេខទូរស័ព្ទចល័តត្រូវបានកំណត់",
    "loginVertif": "ចូលការផ្ទៀងផ្ទាត់",
    "clickGoHome": "ចុចដើម្បីត្រឡប់ទៅទំព័រចូលវិញ",
    "bingPhoneSuccess": "ភ្ជាប់លេខទូរស័ព្ទដៃដោយជោគជ័យ",
    "rightMessageChange": "អ្នកអាចកែសម្រួលវានៅក្នុងព័ត៌មានផ្ទាល់ខ្លួននៅផ្នែកខាងស្តាំនៃរបាររុករក",
    "bingPhone": "ភ្ជាប់លេខទូរស័ព្ទដៃ"
  },
  "index": {
    "setAsHomePage": "រៀបចំជាទំព័រមុខ",
    "addCollection": "បន្ថែមទៅចំណូលចិត្ត",
    "telephone": "គាំទ្រខ្សែទូរស័ព្ទ",
    "Help": "មជ្ឈមណ្ឌល​ជំនួយ",
    "SystemMessage": "កម្មវិធីរំលឹកប្រព័ន្ធ",
    "message": "ព័ត៌មាន",
    "emptyMessage": "ទទេ",
    "checkAllMessage": "មើលទាំងអស់",
    "noMessage": "គ្មាន​ទិន្នន័យ",
    "fullScreen": "ការបង្ហាញពេញអេក្រង់",
    "ExitSystem": "ចេញពីប្រព័ន្ធនេះ",
    "back": "ត្រឡប់មកវិញ",
    "top": "ខាងលើ",
    "backToTop": "ត្រលប់​ទៅ​ខាងលើ",
    "homePage": "ផ្ទះ",
    "course": "ការរៀនវគ្គសិក្សា",
    "onlineCourse": "ថ្នាក់ពិសេសតាមអ៊ិនធរណេត",
    "faceCourse": "ការបណ្តុះបណ្តាលមុខទល់មុខគ្នា",
    "examPractice": "ការអនុវត្តប្រឡង",
    "dataDownLoad": "ទាញយក",
    "userInfo": "មជ្ឈមណ្ឌលផ្ទាល់ខ្លួន",
    "Administration": "សាវតាការគ្រប់គ្រង",
    "courseCategory": "ប្រភេទវគ្គសិក្សា",
    "examIsOver": "ការវាយតម្លៃត្រូវបានបញ្ចប់",
    "onlineHours": "ម៉ោងលើអ៊ីនធឺណិត",
    "faceHours": "ម៉ោងរៀនទល់មុខគ្នា",
    "notice": "ការប្រកាស",
    "checkAllNotice": "មើលទាំងអស់",
    "backToTopButton": "ត្រលប់​ទៅ​ខាងលើ",
    "recommendCourse": "វគ្គសិក្សាដែលបានណែនាំ",
    "impotentCourse": "វគ្គសិក្សាសំខាន់",
    "newCourse": "វគ្គសិក្សាចុងក្រោយ",
    "hotCourse": "វគ្គក្តៅបំផុត",
    "requiredCourses": "វគ្គសិក្សាជាកាតព្វកិច្ច",
    "electiveCourses": "វគ្គសិក្សាជ្រើសរើស",
    "startStudy": "ចាប់ផ្តើមរៀន",
    "continueStudy": "បន្តការសិក្សា",
    "coursesRanking": "ចំណាត់ថ្នាក់ជ្រើសរើសវគ្គសិក្សា",
    "studentRanking": "ចំណាត់ថ្នាក់សិស្ស",
    "currentUser": "អ្នកប្រើប្រាស់បច្ចុប្បន្ន",
    "userHead": "រូបភាពប្រវត្តិរូប",
    "currentHead": "រូបតំណាងបច្ចុប្បន្ន",
    "change": "កែប្រែ",
    "accountPassword": "ពាក្យសម្ងាត់គណនី",
    "encryPhone": "ទូរស័ព្ទសម្ងាត់",
    "currentPhone": "ទូរស័ព្ទបច្ចុប្បន្ន",
    "userName": "ឈ្មោះ​អ្នកប្រើប្រាស់",
    "head": "អាវ៉ាតា",
    "coverImage": "គម្របរូបភាព",
    "uploadError": "ការផ្ទុកឡើងបានបរាជ័យ",
    "autoSetHomeTips": "កម្មវិធីអ៊ីនធឺណិតរបស់អ្នកមិនគាំទ្រការកំណត់ទំព័រដើមដោយស្វ័យប្រវត្តិសូមប្រើមឺនុយកម្មវិធីរុករកដើម្បីកំណត់វាដោយដៃ!",
    "operateConfig": "ប្រតិបត្តិការនេះត្រូវបានបដិសេធដោយ browser ប្រសិនបើអ្នកចង់បើកមុខងារនេះសូមបញ្ចូលអំពី៖ config នៅក្នុងរបាអាស័យដ្ឋានហើយបន្ទាប់មកកំណត់តំលៃនៃចុះហត្ថលេខា.applets.codebase_principal_supportទៅពិត។",
    "favoriteTips": "ដោយសារតែដែនកំណត់នៃមុខងារ browser ៣៦០ សូមចុចបញ្ជា (Ctrl) + D ដើម្បីចំណាំដោយដៃ!",
    "autoFavorite": "កម្មវិធីរុករករបស់អ្នកមិនគាំទ្រវាទេសូមចុចបញ្ជា (Ctrl) + D ដើម្បីចំណាំដោយដៃ!",
    "required": "ធាតុនេះត្រូវបានទាមទារ",
    "to": "ទៅ",
    "trainingTime": "រយៈពេលបណ្តុះបណ្តាល",
    "coursehours": "ម៉ោងសិក្សា",
    "human": "ប្រជាជន",
    "wecome": "សូមស្វាគមន៍!",
    "allCourses": "វគ្គសិក្សាទាំងអស់"
  },
  "course": {
    "coursesCategory": "ប្រភេទវគ្គសិក្សា",
    "allCourses": "វគ្គសិក្សាទាំងអស់",
    "electiveCourses": "វគ្គសិក្សាជ្រើសរើស",
    "requiredCourses": "វគ្គសិក្សាដែលត្រូវការ",
    "collect": "ចំណូលចិត្ត",
    "cancelCollect": "មិនចូលចិត្ត",
    "searchTips": "សូមបញ្ចូលឈ្មោះវគ្គសិក្សា",
    "startStudy": "ចាប់ផ្តើមរៀន",
    "continueStudy": "បន្តការសិក្សា",
    "cancelConfirm": "មិនចូលចិត្ត",
    "cancelTips": "បញ្ជាក់លុបចោលប្រអប់បញ្ចូល",
    "confirmButton": "ប៊ូតុងបោះបង់",
    "count": "សរុប",
    "item": "មាត្រា",
    "up": "ទំព័រ​មុន",
    "next": "ទំ​ព​រ័​បន្ទាប់",
    "items": "អត្ថបទ / ទំព័រ",
    "go": "លោត​ទៅ",
    "page": "ទំព័រ",
    "man": "ប្រជាជន",
    "score": "នាទី",
    "courseYear": "ឆ្នាំ",
    "courseTeachers": "គ្រូ",
    "noDesc": "គ្មានការណែនាំ",
    "teachersDesc": "ប្រវត្តិគ្រូ",
    "checkLog": "មើលកំណត់ត្រា",
    "reExam": "ព្យាយាមម្តងទៀត",
    "examLog": "កំណត់ត្រាប្រឡង",
    "viewPaper": "មើលក្រដាសសាកល្បង",
    "noPublicExam": "ក្រដាសសាកល្បងនឹងមិនត្រូវបានប្រកាសទេ",
    "marking": "សម្គាល់",
    "closeButton": "បិទ",
    "examResultPage": "ទំព័រលទ្ធផលប្រឡង",
    "examPage": "ទំព័រប្រឡង",
    "startExam": "ចាប់ផ្តើមប្រឡង",
    "coursehours": "ម៉ោងសិក្សា",
    "courseInfo": "ព័ត៌មានលំអិតវគ្គសិក្សា",
    "courseChapter": "ជំពូកវគ្គសិក្សា",
    "courseNote": "កំណត់ចំណាំវគ្គសិក្សា",
    "courseData": "ព័ត៌មានវគ្គសិក្សា",
    "courseExamination": "ការប្រឡង",
    "evaluate": "ការវាយតំលៃ",
    "courseEvaluate": "ការវាយតម្លៃវគ្គសិក្សា",
    "no": "ដំបូង",
    "chapter": "ជំពូក",
    "isEvaluate": "បានវាយតម្លៃ",
    "uploadDate": "ពេលវេលាផ្ទុកឡើង",
    "className": "ឈ្មោះថ្នាក់",
    "resourceSize": "ទំហំធនធាន",
    "times": "ដង",
    "typeViedo": "វីដេអូ",
    "typeImage": "រូបភាព",
    "typeDoc": "ឯកសារ",
    "typeOuth": "ផ្សេងទៀត",
    "typeImages": "រូបភាពច្រើន",
    "newComment": "ទាន់សម័យ",
    "hotComment": "ក្តៅបំផុត",
    "openComment": "ខ្ញុំចង់អត្ថាធិប្បាយ",
    "cancelButton": "បោះបង់",
    "publishButton": "ការដោះលែង",
    "commentTips": "សូមបញ្ចូលមាតិកាវិចារណ៍",
    "emptyCommentTips": "មាតិកាមតិយោបល់មិនអាចទទេបានទេ",
    "noteSource": "ពី",
    "deleteNoteButton": "លុប",
    "needIETips": "កម្មវិធីសិក្សាបច្ចុប្បន្នត្រូវការកម្មវិធីបើកអ៊ីយូ!",
    "donwNum": "ដងទាញយក",
    "preview": "មើលជាមុន",
    "relatedCourses": "វគ្គសិក្សាដែលទាក់ទង",
    "studentsNum": "ចំនួនវគ្គសិក្សា",
    "courseHours": "ម៉ោងសិក្សា",
    "JoinLearning": "ចូលរួមរៀនសូត្រ"
  },
  "onlineclass": {
    "allTheClass": "គ្រប់ថ្នាក់",
    "beginClass": "ថ្នាក់បានចាប់ផ្តើម",
    "notBeginClass": "គ្មានថ្នាក់",
    "endClass": "បានបិទ",
    "searchThoseClass": "ស្វែងរកថ្នាក់ពិសេសតាមអ៊ិនធរណេតដែលអ្នកចាប់អារម្មណ៍",
    "startLearn": "ចូលថ្នាក់",
    "registrationTime": "ពេលចុះឈ្មោះ",
    "to": "ទៅ",
    "trainingTime": "រយៈពេលបណ្តុះបណ្តាល",
    "subjectsClass": "វគ្គសិក្សា",
    "classStudy": "ការសិក្សាថ្នាក់",
    "quantityOfCourses": "ចំនួនវគ្គសិក្សា",
    "numberOfParticipants": "ចំនួនបេក្ខជន",
    "registerNow": "ចុះឈ្មោះ​ឥឡូវនេះ",
    "resetRegister": "ដកឈ្មោះចេញ",
    "participating": "បានចូលរួម",
    "subjects": "ទ្វារ",
    "classExam": "ការប្រឡងថ្នាក់",
    "notParticipat": "មិនពាក់ព័ន្ធ",
    "startExim": "ចាប់ផ្តើមប្រឡង",
    "handed": "អនុវត្តកិច្ចការមួយ",
    "score": "ពិន្ទុ",
    "cacheSave": "ការផ្ទុកបណ្តោះអាសន្ន",
    "subjectsNumber": "ចំនួនទ្វារ",
    "notice": "សេចក្តីជូនដំណឹង",
    "communication": "ការ​ទំនាក់ទំនង",
    "detail": "ព័ត៌មានលម្អិត",
    "courses": "វគ្គសិក្សា",
    "allClass": "ទាំងអស់",
    "compulsory": "កំហិត",
    "elective": "ជ្រើសរើស",
    "Learned": "បានរៀន",
    "classPassIndicator": "សូចនាករឆ្លងកាត់ថ្នាក់",
    "excellence": "ល្អបំផុត",
    "compulsoryNumber": "ចំនួនលិខិតឆ្លងដែនដែលត្រូវការ",
    "electiveNumber": "ចំនួនអ្នកបោះឆ្នោតបានឆ្លងកាត់",
    "compulsoryStandard": "ម៉ោងស្តង់ដារជាកាតព្វកិច្ច",
    "electiveStandard": "ម៉ោងជ្រើសរើស",
    "examIsPass": "ថាតើការប្រឡងបានកន្លងផុតទៅដែរឬទេ",
    "resource": "ធនធាន",
    "source": "ទិន្នន័យ",
    "new": "ទាន់សម័យ",
    "hot": "ក្តៅបំផុត",
    "updateTime": "ពេលវេលាផ្ទុកឡើង",
    "downloadCount": "ការទាញយក",
    "download": "ទាញយក",
    "resourceSize": "ទំហំធនធាន",
    "resourceType": "ប្រភេទ​នៃ",
    "allType": "គ្រប់ប្រភេទ",
    "videos": "វីដេអូ",
    "images": "រូបភាព",
    "document": "ឯកសារ",
    "others": "ផ្សេងទៀត",
    "multiImages": "រូបភាពច្រើន",
    "inforCertificate": "វិញ្ញាបនបត្រ",
    "notSubmit": "មិនបានដាក់ជូន",
    "submitHomework": "បញ្ជូនការងារផ្ទះ",
    "submitTime": "ពេលវេលាដាក់ស្នើ",
    "uploadHomework": "ផ្ទេរការងារ",
    "clickHere": "ចុច​ទីនេះ",
    "upload": "ផ្ទុកឡើង",
    "formatSupport": "ការគាំទ្រទ្រង់ទ្រាយឯកសារ",
    "submited": "បានដាក់ស្នើ",
    "notApproved": "មិនបានពិនិត្យមើល",
    "approved": "ការប្រឡងបានកន្លងផុតទៅ",
    "downloadHomework": "ទាញយកកិច្ចការ",
    "reSubmit": "ដាក់ស្នើឡើងវិញ",
    "myScore": "ពិន្ទុរបស់ខ្ញុំ",
    "comments": "យោបល់",
    "talk": "ពិភាក្សា",
    "category": "ចំណាត់ថ្នាក់",
    "classTalk": "ការពិភាក្សាថ្នាក់",
    "groupTalk": "ការពិភាក្សាជាក្រុម",
    "wantTalk": "ខ្ញុំចង់ពិភាក្សា",
    "publish": "ការដោះលែង",
    "undo": "បោះបង់",
    "delete": "លុប",
    "iknow": "ខ្ញុំ​យល់​ហើយ",
    "faceCourseClass": "ការបណ្តុះបណ្តាលមុខទល់មុខគ្នា",
    "onlineClasses": "ថ្នាក់ពិសេសតាមអ៊ិនធរណេត",
    "openReservation": "បើកសម្រាប់ការចុះឈ្មោះ",
    "talkTech": "សាស្រ្តាចារ្យ",
    "address": "ទីតាំង",
    "up": "បើក",
    "noon": "ថ្ងៃត្រង់",
    "down": "នៅក្រោម",
    "even": "យឺត",
    "classOvered": "ចប់ហើយ",
    "nopassed": "មិនទាន់បានចុះឈ្មោះទេ",
    "inputTalkContent": "សូមបញ្ចូលមាតិកាពិភាក្សា",
    "groupMan": "អ្នកដឹកនាំ​ក្រុម",
    "showAllGroup": "មើលសមាជិកទាំងអស់",
    "hideAllGroup": "ដាក់សមាជិកក្រុមទាំងអស់",
    "showAllMan": "មើលនិស្សិតទាំងអស់",
    "hideAllMan": "ដាក់សិស្សទាំងអស់ចោល",
    "reply": "ឆ្លើយតប",
    "isDelete": "តើអ្នកប្រាកដជាចង់លុប?",
    "cancelLike": "មិន​ដូច",
    "classNotStar": "ការចុះឈ្មោះថ្នាក់មិនទាន់ចាប់ផ្តើមនៅឡើយទេ",
    "classIsEnd": "ការចុះឈ្មោះថ្នាក់បានបញ្ចប់",
    "clickReset": "ចុចប៊ូតុងដើម្បីដកឈ្មោះ",
    "agentRegister": "ចុះឈ្មោះម្តងទៀត",
    "cancelRegister": "បោះបង់ការចុះឈ្មោះ",
    "reason": "ហេតុផល",
    "inputReason": "សូមបញ្ចូលមូលហេតុនៃការដកហូត",
    "homework": "ប្រតិបត្តិការ",
    "leaveMaxBits": "មូលហេតុនៃការសុំឈប់សម្រាកមិនអាចលើសពី ១០០ ពាក្យទេ",
    "leaveNotEndTime": "ពេលវេលាចាប់ផ្តើមឈប់សម្រាកមិនអាចស្មើនឹងពេលវេលាបញ្ចប់ឡើយ",
    "sizeNot": "ទំហំមិនអាចលើស",
    "close": "បិទ",
    "teacher": "គ្រូ",
    "noIntroduction": "គ្មានការណែនាំ"
  },
  "offlineclass": {
    "fullTimeToFace": "ការបង្រៀនមុខពេញម៉ោង",
    "onlineToFace": "នៅលើការងារ",
    "allClass": "គ្រប់ថ្នាក់",
    "openClass": "បើកថ្នាក់",
    "searchThoseClass": "ស្វែងរកវគ្គបណ្តុះបណ្តាលមុខមាត់ដែលអ្នកចាប់អារម្មណ៍",
    "startLearn": "បញ្ចូលការរៀនសូត្រ",
    "classHours": "ម៉ោងសិក្សា",
    "h": "ពេលវេលា",
    "firstWeek": "សប្តាហ៍ទី ១",
    "askLeave": "ខ្ញុំចង់ឈប់សម្រាក",
    "monday": "ថ្ងៃច័ន្ទ",
    "tuesday": "ថ្ងៃអង្គារ",
    "wednesday": "ថ្ងៃពុធ",
    "thursday": "ថ្ងៃព្រហស្បតិ៍",
    "fridays": "ថ្ងៃសុក្រ",
    "saturdays": "នៅ​ថ្ងៃ​សៅ​រ៏",
    "sunday": "នៅ​ថ្ងៃអាទិត្យ",
    "morning": "ពេលព្រឹក",
    "afternoon": "នៅពេល​រសៀល",
    "evening": "នៅ​ពេលយប់",
    "leaveType": "ប្រភេទនៃការឈប់សម្រាក",
    "selectLeaveType": "សូមជ្រើសរើសប្រភេទការឈប់សម្រាក",
    "leaveTime": "ពេលវេលាឈប់សម្រាក",
    "selctLeaveTime": "សូមជ្រើសរើសពេលវេលាឈប់សម្រាក",
    "reasonLeave": "ហេតុផលសម្រាប់ការឈប់សម្រាក",
    "inputReasonLeave": "សូមបញ្ចូលមូលហេតុនៃការឈប់សម្រាក",
    "sure": "កំណត់",
    "selectTime": "រយៈពេលជ្រើសរើស",
    "casualLeave": "ការឈប់សម្រាកផ្ទាល់ខ្លួន",
    "sickLeave": "ឈប់​សម្រាក​ដោយ​សារ​ជម្ងឺ",
    "seven": "ថ្ងៃ",
    "one": "មួយ",
    "two": "ពីរ",
    "three": "បី",
    "for": "បួន",
    "five": "ចុកពោះ",
    "six": "ប្រាំមួយ",
    "clear": "ទទេ",
    "evaluating": "ការវាយតំលៃ",
    "courseEvaluation": "ការវាយតម្លៃការបង្រៀន",
    "inputEvaluating": "សូមបញ្ចូលមាតិកាវាយតម្លៃ",
    "beDoing": "កំពុង​ដំណើរការ",
    "notStarted": "មិនបានចាប់ផ្តើមទេ",
    "evaluationInProgress": "ការវាយតំលៃកំពុងដំណើរការ",
    "notEvaluation": "មិនបានវាយតម្លៃ",
    "evaluationStartTime": "ការវាយតម្លៃពេលវេលាចាប់ផ្តើម",
    "startEvaluation": "ចាប់ផ្តើមវាយតម្លៃ",
    "classEvaluation": "ការវាយតម្លៃថ្នាក់",
    "photoCategory": "ចំណាត់ថ្នាក់អាល់ប៊ុម",
    "learningActivity": "សកម្មភាពរៀន",
    "addPhoto": "បានបន្ថែមរូបថតថ្មី",
    "photoMessage": "ព័ត៌មានរូបថត",
    "photoName": "ឈ្មោះរូបថត",
    "inputPhotoName": "សូមបញ្ចូលឈ្មោះរូបថត",
    "uploadPhoto": "ផ្ទុករូបថតឡើង",
    "formatSupport": "ការគាំទ្រទ្រង់ទ្រាយគាំទ្រ",
    "tickets": "ចាង",
    "group": "ក្រុម",
    "notGroup": "មិនបានបែងចែក",
    "groupTalk": "ការពិភាក្សាជាក្រុម",
    "teacherAbout": "ប្រវត្តិគ្រូ",
    "teacherTech": "វគ្គសិក្សាត្រូវបានយក",
    "photos": "អាល់ប៊ុមរូបថត",
    "phontoRequier": "រូបថតត្រូវតែផ្ទុកឡើង",
    "addPhoneTips": "បន្ថែមដោយជោគជ័យសូមរង់ចាំពិនិត្យឡើងវិញ",
    "sureDelete": "តើអ្នកប្រាកដជាចង់លុប",
    "deleteSuccess": "បានលុបដោយជោគជ័យ",
    "phoneNameReq": "វាលឈ្មោះរូបថតត្រូវបានទាមទារ",
    "longNotBits": "ប្រវែងមិនលើសពី ៥០ តួអក្សរ",
    "phoneIsOccur": "ឈ្មោះរូបថតមានរួចហើយ",
    "evaluateTime": "វាយតម្លៃពេលវេលា",
    "evalueteNotStar": "ការវាយតំលៃមិនបានចាប់ផ្តើមទេ",
    "evaluateEnds": "ការវាយតំលៃបានបញ្ចប់",
    "isEvaluated": "បានសន្មត់",
    "at": "ក្នុង",
    "submit": "ដាក់ស្នើ",
    "seeEvalute": "ការវាយតំលៃមើល",
    "inputIdea": "សូមបញ្ចូលគំនិតរបស់អ្នក",
    "submitFailure": "បានបរាជ័យក្នុងការប្រគល់ឱ្យ",
    "seeRecord": "មើលកំណត់ត្រា",
    "examRecord": "កំណត់ត្រាប្រឡង",
    "seeSubmite": "មើលក្រដាសសាកល្បង",
    "resultPage": "ទំព័រលទ្ធផលប្រឡង",
    "hoursStandard": "មិនអាចប្រឡងបានទេបើម៉ោងរៀនមិនឡើងតាមស្តង់ដារ",
    "examPage": "ទំព័រប្រឡង",
    "questionnaire": "កម្រងសំណួរ",
    " coursesTaught": "វគ្គសិក្សាត្រូវបានបង្រៀន",
    "passed": "ដោយ",
    "is": "ត្រូវហើយ",
    "not": "ទេ",
    "passedState": "ស្ថានភាពឆ្លងកាត់",
    "sketch": "ពង្រាង",
    "partySchool": "ថ្នាក់បណ្តុះបណ្តាលសាលាគណបក្ស",
    "searchPartySchool": "ស្វែងរកថ្នាក់បណ្តុះបណ្តាលសាលាគណបក្សដែលអ្នកចាប់អារម្មណ៍"
  },
  "exam": {
    "answerWarning": "សំណួរនៃការប្រឡងនេះគឺជាសំនួរតែមួយដែលមិនអាចត្រឡប់វិញបានទេសូមមេត្តាប្រុងប្រយ័ត្នមុនពេលសំនួរបន្ទាប់",
    "inputAnswerTips": "សូមបញ្ចូលចម្លើយរបស់អ្នក",
    "problemPoints": "ការវិភាគបញ្ហា",
    "examination": "ចុះឈ្មោះសម្រាប់ការប្រឡង",
    "knowledgeCompetition": "ការប្រលងចំណេះដឹង",
    "practice": "ការអនុវត្តស្វ័យភាព",
    "notRegister": "មិនបានចុះឈ្មោះ",
    "reviewAudit": "កំពុងពិនិត្យ",
    "auditNoPass": "សវនកម្មបានបរាជ័យ",
    "participanted": "បានចុះឈ្មោះ",
    "participant": "ចុះ​ឈ្មោះ",
    "examTime": "ពេលវេលាប្រឡង",
    "examHours": "រយៈពេល",
    "registration": "ចុះឈ្មោះដោយជោគជ័យ",
    "reRegistration": "ដកឈ្មោះចេញ",
    "wrongQuestion": "ធនាគារសំណួរមិនត្រឹមត្រូវ",
    "noInvolvement": "មិនពាក់ព័ន្ធ",
    "involvement": "ចូលរួម",
    "searchExamPractice": "ស្វែងរកការប្រឡងនិងលំហាត់ដែលអ្នកចាប់អារម្មណ៍",
    "practiced": "អនុវត្ត",
    "startPractice": "ចាប់ផ្តើមអនុវត្ត",
    "toFavorite": "បន្ថែមទៅសំណព្វ",
    "prevPrevious": "សំណួរមុន",
    "nextPrevious": "សំណួរ​បន្ទាប់",
    "submitAnswers": "បញ្ជូនចម្លើយ",
    "rightAnswers": "ចម្លើយ​ត្រឹមត្រូវ",
    "yourAnswers": "ចម្លើយ​របស់​អ្នក",
    "questionsAnalysis": "ការវិភាគសំណួរ",
    "noAnalysis": "គ្មានដំណោះស្រាយ",
    "accuracy": "អត្រាត្រឹមត្រូវ",
    "continuePracticed": "រក្សាការអនុវត្ត",
    "topics": "ប្រធានបទ"
  },
  "source": {
    "allResource": "ធនធានទាំងអស់",
    "commonResource": "ធនធានទូទៅ",
    "classResource": "ធនធានថ្នាក់",
    "resourceCategory": "ការបែងចែកធនធាន",
    "searchResource": "ស្វែងរកធនធានដែលអ្នកចាប់អារម្មណ៍",
    "resourceTalk": "ការវាយតម្លៃធនធាន",
    "previewResource": "ការមើលធនធានជាមុន",
    "helpPoint": "សៀវភៅណែនាំជំនួយ",
    "isEvaluation": "អ្នកបានវាយតម្លៃរួចហើយ!",
    "selectEvaluation": "អ្នកមិនបានជ្រើសរើសចំណាត់ថ្នាក់ទេ!",
    "evaluationSuccess": "ការវាយតម្លៃដោយជោគជ័យ",
    "topRelise": "ខាងលើ",
    "className": "ឈ្មោះថ្នាក់",
    "resourceEvaluation": "ចំណាត់ថ្នាក់ធនធាន"
  },
  "usercenter": {
    "386": "ឯកសារសិក្សា",
    "myCourse": "វគ្គសិក្សារបស់ខ្ញុំ",
    "hours": "ពេលវេលា",
    "loginAccount": "ចូលគណនី",
    "htllo": "សួស្តី",
    "welcomeMessage": "សូមជូនពរឱ្យអ្នកសប្បាយរីករាយជារៀងរាល់ថ្ងៃ",
    "underway": "អ្នក​កំពុង​ធ្វើ",
    "annualAssessment": "ការវាយតម្លៃប្រចាំឆ្នាំ",
    "searchTips": "បញ្ចូលឈ្មោះវគ្គសិក្សាដែលបានស្វែងរក",
    "completed": "ចប់ហើយ",
    "allCourses": "វគ្គសិក្សាទាំងអស់",
    "requiredCourses": "វគ្គសិក្សាដែលត្រូវការ",
    "electiveCourses": "វគ្គសិក្សាជ្រើសរើស",
    "all": "ទាំងអស់",
    "ongoing": "ដំណើរការ",
    "learnTo": "រៀន​ដើម្បី",
    "inExams": "ធ្វើតេស្ត",
    "noExams": "គ្មានការប្រឡងទេ",
    "delete": "លុប",
    "pleaseSelect": "សូម​ជ្រើសរើស",
    "searchOnlineTips": "ស្វែងរកថ្នាក់ពិសេសតាមអ៊ិនធរណេតដែលអ្នកចាប់អារម្មណ៍",
    "passedCourse": "ឆ្លងកាត់",
    "failedCourse": "មិនបានហុច",
    "myOnlineCourse": "ថ្នាក់ពិសេសតាមអ៊ិនធរណេតរបស់ខ្ញុំ",
    "myFaceCourse": "ថ្នាក់បណ្តុះបណ្តាលមុខរបស់ខ្ញុំ",
    "searchFaceTips": "ស្វែងរកវគ្គសិក្សាដែលអ្នកចាប់អារម្មណ៍",
    "myExams": "ការប្រលងរបស់ខ្ញុំ",
    "allExams": "ការប្រឡងទាំងអស់",
    "makeUpExam": "ត្រូវបានបង្កើតឡើង",
    "marking": "សម្គាល់",
    "onExam": "ការប្រឡងកំពុងដំណើរការ",
    "passedExam": "ការប្រឡងបានកន្លងផុតទៅ",
    "examHours": "រយៈពេលសាកល្បង",
    "examOver": "ការប្រឡងចប់",
    "exam": "ការពិនិត្យ",
    "examLog": "កំណត់ត្រាប្រឡង",
    "myScore": "ពិន្ទុរបស់ខ្ញុំ",
    "surplusMakeUpExam": "ការប្រឡងតុបតែងដែលនៅសល់",
    "times": "ដង",
    "searchExamTips": "បញ្ចូលឈ្មោះនៃការស្វែងរក",
    "haveTime": "ពេលវេលានៅសល់",
    "question": "សំណួរ",
    "eachQuestion": "សំណួរនីមួយៗ",
    "score": "នាទី",
    "examExplain": "ការពិពណ៌នាការប្រឡង",
    "confirmHandExams": "ថាតើត្រូវបញ្ជាក់ពីការដាក់ស្នើ",
    "autoSaveFailed": "ការរក្សាទុកដោយស្វ័យប្រវត្តិបានបរាជ័យ",
    "autoSaveSuccess": "រក្សាទុកដោយស្វ័យប្រវត្តិ",
    "handExamsSuccess": "បានប្រគល់ដោយជោគជ័យ",
    "yourScore": "ពិន្ទុ​របស់​អ្នក",
    "noPublicAnswers": "ចម្លើយនឹងមិនត្រូវបានប្រកាសសម្រាប់ការប្រឡងនេះទេ",
    "noPublicResult": "ក្រដាសសាកល្បងនឹងមិនត្រូវបានប្រកាសទេ",
    "reExam": "ព្យាយាមម្តងទៀត",
    "practice": "ធ្វើលំហាត់ប្រាណ",
    "hasCollected": "ប្រមូល",
    "emptyAnswer": "ជម្រើសឬចម្លើយមាតិកាមិនអាចទទេបានទេ",
    "isCorrect": "ដំណោះស្រាយវិជ្ជមាន",
    "myCollected": "ការប្រមូលរបស់ខ្ញុំ",
    "courseCollected": "ការប្រមូលវគ្គសិក្សា",
    "examCollected": "សំណួរសាកល្បង",
    "deleteCollected": "យកសំណព្វចេញ",
    "myLeave": "ការឈប់សម្រាករបស់ខ្ញុំ",
    "allLeave": "ការឈប់សម្រាកទាំងអស់",
    "needAudit": "រង់ចាំ",
    "auditDate": "ពេលវេលាដាក់ពាក្យ",
    "searchLeaveTips": "ស្វែងរកការឈប់សម្រាកដែលអ្នកចាប់អារម្មណ៍",
    "checkInfo": "មើលព័ត៌មានលម្អិត",
    "cancelLeave": "ដកហូតការឈប់សម្រាក",
    "leaveInfo": "ទុកព័ត៌មានលម្អិត",
    "leaveState": "ស្ថានភាពបច្ចុប្បន្ន",
    "teamLeader": "អ្នកដឹកនាំ​ក្រុម",
    "committeeMembers": "គណៈកម្មាធិការត្រួតពិនិត្យវិន័យអង្គភាព",
    "headmaster": "ប្រធានគ្រូ",
    "schoolLeader": "អ្នកដឹកនាំសាលា",
    "student": "សិក្ខាកាម",
    "auditMessage": "ហេតុផលសម្រាប់ការអនុម័ត",
    "onBusiness": "សំរាប់​ជំនួញ",
    "personal": "សម្រាប់ហេតុផលផ្ទាល់ខ្លួន",
    "rejectReasons": "ហេតុផលសម្រាប់ការបដិសេធ",
    "confirmCancel": "បញ្ជាក់ថាតើត្រូវលុបចោលការឈប់សម្រាកនេះដែរឬទេ",
    "cancelButton": "បញ្ឈប់សុពលភាព",
    "cancelTitle": "ការបញ្ជាក់ដកហូត",
    "empty": "ទេ",
    "wrongQuestionBank": "ធនាគារសំណួរខុសរបស់ខ្ញុំ",
    "searchWrongTips": "ស្វែងរកសំណួរខុសដែលអ្នកចាប់អារម្មណ៍",
    "deleteWrongQuestion": "ដកធនាគារសំណួរខុស",
    "myQuestionnaire": "កម្រងសំណួររបស់ខ្ញុំ",
    "isCompleted": "បានបញ្ចប់",
    "isOver": "លើស",
    "searchQuestionnaireTips": "បញ្ចូលឈ្មោះសំណួរស្វែងរក",
    "questionnaireDate": "ពេលវេលាសំណួរ",
    "startQuestionnaire": "ចាប់ផ្តើមឆ្លើយ",
    "checkQuestionnaire": "មើលកម្រងសំណួរ",
    "allTeacher": "គ្រូទាំងអស់",
    "newTeacher": "បន្ថែមគ្រូ",
    "searchTeacherTips": "ស្វែងរកគ្រូដែលអ្នកចាប់អារម្មណ៍",
    "checkTeacher": "មើល",
    "editTeacher": "កែប្រែ",
    "workingIn": "បានធ្វើការនៅ",
    "location": "ទីតាំងអចិន្រ្តៃយ៍",
    "confirmDelete": "លុបការបញ្ជាក់",
    "confirmDeleteTips": "បញ្ជាក់ការលុប",
    "recommendTeacher": "អនុសាសន៍របស់គ្រូ",
    "addTeachers": "គ្រូថ្មី",
    "teacherInfo": "ព័ត៌មាន​ផ្ទាល់ខ្លួន",
    "teacherName": "ឈ្មោះគ្រូ",
    "workUnit": "និយោជក",
    "contact": "ព័ត៌មានលម្អិតទំនាក់ទំនង",
    "teacherNameTips": "សូមបញ្ចូលឈ្មោះគ្រូ",
    "teacherWorkUnitTips": "សូមបញ្ចូលនិយោជក",
    "teacherContactTips": "សូមបញ្ចូលព័ត៌មានទំនាក់ទំនងរបស់គ្រូ",
    "teacherLocationTips": "សូមបញ្ចូលទីតាំងអចិន្រ្តៃយ៍",
    "teacherDescTips": "សូមបញ្ចូលប្រវត្តិរូបគ្រូ",
    "teachingInfo": "ការបង្រៀនព័ត៌មាន",
    "teachingExpertise": "បង្រៀនជំនាញ",
    "fitLevel": "សមស្របសម្រាប់កម្រិតបង្រៀនវត្ថុ",
    "fitBusiness": "សមស្របសម្រាប់ខ្សែអាជីវកម្ម",
    "ruleNumber": "សូមបញ្ចូលលេខគត់ក្នុងខ្ទង់ ៨ ខ្ទង់ (រួមទាំង ៨)",
    "rulePhone": "សូមបញ្ចូលលេខទូរស័ព្ទត្រឹមត្រូវ",
    "ruleString": "សូមបញ្ចូល ៨០ តួអក្សរ (រួមទាំង ៨០)",
    "ruleIsNumber": "សូមបញ្ចូលលេខ",
    "pause": "ការផ្ទុកបណ្តោះអាសន្ន",
    "teachingStyle": "ស្ទីលបង្រៀន",
    "teachingExpertiseTips": "សូមបញ្ចូលជំនាញបង្រៀនរបស់គ្រូ",
    "fitLevelTips": "សូមជ្រើសរើសកំរិតដែលសាកសមនឹងទស្សនិកជនគោលដៅ",
    "fitBusinessTips": "សូមជ្រើសរើសខ្សែបន្ទាត់អាជីវកម្មដែលសមរម្យ",
    "chargeInfoTips": "សូមបញ្ចូលស្តង់ដារសាក",
    "teachingStyleTips": "សូមបញ្ចូលស្ទីលបង្រៀនរបស់គ្រូ",
    "otherInfo": "ព័ត៌មាន​ផ្សេងទៀត",
    "recommendUnit": "ណែនាំដោយ",
    "otherOption": "បញ្ហាផ្សេងៗ",
    "otherOptionTips": "សូមបញ្ចូលអ្វីផ្សេងទៀតដែលត្រូវការបន្ថែម",
    "isRequired": "ធាតុនេះត្រូវបានទាមទារ",
    "pauseSuccess": "បានរក្សាទុកដោយជោគជ័យ",
    "phoneWrong": "សូមបញ្ចូលលេខទូរស័ព្ទត្រឹមត្រូវ",
    "junior": "សិស្សអនុវិទ្យាល័យ",
    "highSchool": "សិស្ស​វិទ្យាល័យ",
    "english": "អង់គ្លេស",
    "mathematics": "គណិតវិទ្យា",
    "recommendSuccessTips": "អ្នកបានបញ្ជូនគ្រូដែលបានណែនាំឱ្យជោគជ័យហើយបន្ទាប់ពីការពិនិត្យចប់គ្រូនឹងត្រូវបញ្ចូលទៅក្នុងអាងគ្រូ",
    "goBackrecommend": "ត្រឡប់ទៅអនុសាសន៍របស់គ្រូ",
    "checkTeacherInfo": "មើលគ្រូ",
    "currentState": "ស្ថានភាពបច្ចុប្បន្ន",
    "chargeInfo": "ការគិតប្រាក់",
    "myCertificate": "វិញ្ញាបនប័ត្ររបស់ខ្ញុំ",
    "learningArchives": "ឯកសារសិក្សា",
    "allCertificate": "វិញ្ញាបនបត្រទាំងអស់",
    "onlineCourse": "ថ្នាក់លើអ៊ីនធឺណិត",
    "faceCourse": "ថ្នាក់មុខទល់មុខគ្នា",
    "exams": "ការពិនិត្យ",
    "baseInfo": "ព័ត៌មានមូលដ្ឋាន",
    "userName": "ឈ្មោះ​អ្នកប្រើប្រាស់",
    "name": "ឈ្មោះ",
    "company": "ឯកតាបច្ចុប្បន្ន",
    "learningExperience": "សិក្សាប្រវត្តិសាស្រ្ត",
    "assessmentIndex": "សន្ទស្សន៍វាយតម្លៃ",
    "assessmentStatus": "ស្ថានភាពវាយតម្លៃ",
    "assessmentTime": "ពេលវេលាសាកល្បង",
    "onlineLearning": "ការសិក្សាតាមអ៊ិនធរណេត",
    "year": "ឆ្នាំ",
    "faceOutProduceHours": "ការណែនាំទល់មុខគ្នា (ម៉ោងរៀន)",
    "notFaceOutProduceHours": "ការបង្រៀនមុខមិនពេញម៉ោង (ម៉ោងសិក្សា)",
    "onlineCenterLearnHours": "ការរៀនសូត្រដែលពឹងផ្អែកខ្លាំងលើអ៊ីនធឺណិត (ម៉ោងសិក្សា)",
    "onlineSelfLearnHours": "ការរៀនដោយខ្លួនឯងតាមអ៊ិនធឺរណែត (ម៉ោងសិក្សា)",
    "outCompanyLearnHours": "សិក្សានៅបរទេស (ម៉ោងសិក្សា)",
    "allHours": "រយៈពេលសរុប",
    "onlineSelfLearn": "ការរៀនតាមអ៊ិនធរណេត",
    "onlineCentralizedLearning": "ការរៀនសូត្រដែលពឹងផ្អែកខ្លាំងលើអ៊ីនធឺណិត",
    "outCompanyLearn": "ការសិក្សាឯកតាបរទេស",
    "faceTrain": "ការបណ្តុះបណ្តាលមុខទល់មុខគ្នា",
    "myNotice": "សាររបស់ខ្ញុំ",
    "noticeSearchTips": "ស្វែងរកព័ត៌មានដែលអ្នកចាប់អារម្មណ៍",
    "systemNotice": "កម្មវិធីរំលឹកប្រព័ន្ធ",
    "message": "លិខិតឯកជន"
  },
  "questionnaire": {
    "notParticipat": "មិនពាក់ព័ន្ធ",
    "description": "ការពិពណ៌នាកម្រងសំណួរ",
    "save": "រក្សាទុក",
    "export": "នាំចេញ",
    "printing": "បោះពុម្ព",
    "handed": "អនុវត្តកិច្ចការមួយ",
    "topics": "ប្រធានបទ",
    "examList": "បញ្ជីសំណួរសាកល្បង",
    "tableQuestions": "សំណួរតារាង",
    "newLine": "បន្ថែមជួរដេក",
    "deleteLine": "លុបជួរដេក",
    "sort": "លេខ​សម្គាល់",
    "content": "មាតិកា",
    "shortQuestion": "ចម្លើយ​ខ្លី",
    "inputContent": "សូមបញ្ចូលមាតិកាចម្លើយ",
    "multiple": "ពហុ​ជ្រើសរើស",
    "single": "ពហុ​ជ្រើសរើស",
    "saveSuccess": "បានរក្សាទុកដោយជោគជ័យ",
    "submitSuccess": "បានដាក់ស្នើដោយជោគជ័យ",
    "submitTips": "អ្នកបានដាក់កម្រងសំណួររួចរាល់ហើយសូមអរគុណចំពោះការចូលរួមរបស់អ្នក",
    "closePage": "បិទទំព័រនេះ"
  },
  "play": {
    "endStudy": "ចប់ការសិក្សា",
    "tips": "ព័ត៌មានជំនួយ",
    "playTips": "ការរំលឹកៈដើម្បីធានាថាពេលវេលាសិក្សារបស់អ្នកត្រូវបានកត់ត្រាដោយប្រព័ន្ធសូមចុចប៊ូតុង“ បញ្ចប់ការសិក្សា” នៅជ្រុងខាងស្តាំខាងលើដើម្បីចេញពីការសិក្សាប្រសិនបើអ្នកបិទកម្មវិធីរុករកដោយផ្ទាល់ពេលវេលានៃការសិក្សារបស់អ្នកប្រហែលជាមិនត្រូវបានកត់ត្រាជាធម្មតាទេ។",
    "notShowAgain": "កុំសួរសារនេះម្តងទៀត",
    "gotIt": "ខ្ញុំ​យល់​ហើយ",
    "chapter": "ជំពូក",
    "chapterText1": "ដំបូង",
    "chapterText2": "ជំពូក",
    "note": "កំណត់ចំណាំ",
    "noteBlockTitle": "កំណត់ចំណាំ",
    "evaluate": "ការវាយតំលៃ",
    "evaluateStar": "ផ្កាយ",
    "saveEvaluate": "ដាក់ស្នើ",
    "notePlaceholder": "សូមបញ្ចូលកំណត់ចំណាំ",
    "closeTips": "ប្រព័ន្ធប្រហែលជាមិនរក្សាទុកការផ្លាស់ប្តូររបស់អ្នកទេ",
    "closeButton": "ទៅ​ឆ្ងាយ",
    "autoStop": "ឈប់លេងដោយស្វ័យប្រវត្តិ",
    "autoStopTips": "ដោយសារតែអ្នកមិនបានដំណើរការអស់រយៈពេលជាយូរមកហើយប្រព័ន្ធបានបញ្ឈប់ការចាក់វីដេអូឡើងវិញដោយស្វ័យប្រវត្តិ",
    "confirmOut": "តើអ្នកប្រាកដជាឈប់លេងមែនទេ?",
    "closeOrNot": "ថាតើត្រូវបិទបង្អួចបច្ចុប្បន្ន",
    "noCoursePlay": "មិនមានវគ្គសិក្សាដែលអាចលេងបានទេនៅក្នុងវគ្គសិក្សាបច្ចុប្បន្ន",
    "attention": "សូម​ចំណាំ!"
  }
};